/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum passengerTitleEnum {
  H = 'H',
  D = 'D',
  K = 'K',
  B = 'B',
}
